import { createStyles } from '@mantine/core';
import Banner from '../../../assets/images/editlistBanner.png';
import { body_min_height } from '../../../utils/const.js';
export const useStyles = createStyles((theme) => ({
  wrapper: {
    background: 'rgba(224,244,245,0.5)',
    paddingBottom: 70,
    paddingTop: 70,
    backgroundImage: `url(${Banner})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    height: '80vh',
    [theme.fn.smallerThan(800)]: {
      backgroundImage: 'none'
    },
    [theme.fn.largerThan(786)]: {
      minHeight: `${body_min_height.desktop} !important`
    }
  },
  textInput: {
    width: '100%',
    input: {
      padding: 23,
      borderRadius: 13,
      border: '2px solid white',
      outline: 'none',
      background: '#F7F9FA',
      transition: '.5s',
      fontFamily: `Medium , ${theme.fontFamily}`,
      fontSize: 13,
      borderColor: theme.colors.primary[0],
      background: '#E1F4F5',
      boxShadow: '0px 15px 25px 0px #00D89B26',

      color: theme.colors.text[1],
      '&:focus': {
        fontFamily: `Regular , ${theme.fontFamily}`,
        fontWeight: 'bold',
        color: theme.colors.secondary[0],
        borderColor: theme.colors.primary[0]
      },
      '&:disabled': {
        color: `${theme.colors.text[1]}`,
        opacity: 1,
        fontWeight: 'bold',
        borderColor: theme.colors.tertiary[0]
      }
    }
  },
  tableContainer: {
    width: '80%',
    margin: 'auto',
    [theme.fn.smallerThan(1400)]: {
      width: '90%'
    },
    [theme.fn.smallerThan(1050)]: {
      width: '95%',
      overflowX: 'scroll'
    },
    [theme.fn.smallerThan(800)]: {
      marginTop: 10
    }
  },
  table: {
    backgroundColor: theme.colors.background[0],
    width: '100%',
    margin: 'auto',
    marginTop: 20,
    marginBlock: 20,
    borderRadius: 10,
    [theme.fn.smallerThan(1050)]: {
      width: 1200
    },
    [theme.fn.smallerThan(850)]: {
      width: 760
    }
  },
  headerAndSearch: {
    width: '80%',
    margin: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    [theme.fn.smallerThan(1400)]: {
      width: '90%'
    },
    [theme.fn.smallerThan(1050)]: {
      width: '95%'
    },
    [theme.fn.smallerThan(800)]: {
      flexDirection: 'column',
      alignItems: 'center',
      rowGap: 20
    }
  },
  searchAndFilter: {
    display: 'flex',
    justifyContent: 'space-between',
    columnGap: 20,
    [theme.fn.smallerThan(800)]: {
      width: '100%'
    },
    button: {
      boxShadow: '0px 2px 2px rgba(29, 94, 109, 0.05)'
    },
    'div[name="filterIcon"]': {
      boxShadow: '0px 2px 2px rgba(29, 94, 109, 0.05)'
    }
  },

  searchIcon: {
    position: 'absolute',
    top: 10,
    left: 10,
    zIndex: 99,
    width: 16,
    height: 16,
    [theme.fn.smallerThan(800)]: {
      width: 20,
      height: 20,
      background: 'red'
    }
  },
  searchInput: {
    width: 350,
    border: 'none !important',
    [theme.fn.smallerThan(800)]: {
      width: '100%'
    },
    input: {
      border: 'none',
      borderRadius: 16,
      fontSize: 16,
      color: theme.colors.text[1],
      fontFamily: `Regular, ${theme.fontFamily}`,
      height: 50,
      [theme.fn.smallerThan(800)]: {
        fontSize: 16,
        height: 50
      }
    }
  },
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 10,
    background: 'white',
    borderRadius: 16,
    paddingLeft: 10,
    paddingRight: 10,
    height: 50,
    [theme.fn.smallerThan(500)]: {
      width: 50,
      height: 50,
      borderRadius: 10,
      paddingLeft: 12
    }
  },
  filterIcon: {
    width: 48,
    height: 12,
    [theme.fn.smallerThan(800)]: {
      width: 20,
      height: 20
    }
  },
  filter: {
    fontFamily: `Regular, ${theme.fontFamily}`,
    fontSize: 16,
    color: theme.colors.text[1],
    [theme.fn.smallerThan(500)]: {
      display: 'none'
    }
  },
  title: {
    fontSize: 26,
    fontFamily: `Medium, ${theme.fontFamily}`,
    color: theme.colors.secondary[0]
  },
  tableHead: {
    backgroundColor: theme.colors.secondary[0],
    height: 50
  },
  columnHeading: {
    color: 'white !important',
    fontFamily: `SemiBold, ${theme.fontFamily}`,
    ':first-child': {
      borderTopLeftRadius: 10,
      fontSize: 14,
      letterSpacing: 0.15
    },
    ':nth-child(2)': {
      fontSize: 14,
      letterSpacing: 0.15
    },
    ':nth-child(3)': {
      fontSize: 14,
      letterSpacing: 0.15
    },
    ':nth-child(4)': {
      fontSize: 14,
      letterSpacing: 0.15,
      minWidth: '150px'
    },
    ':nth-child(5)': {
      fontSize: 14,
      letterSpacing: 0.15,
      minWidth: '150px'
    },
    ':nth-child(6)': {
      fontSize: 14,
      letterSpacing: 0.15,
      minWidth: '150px'
    },
    ':last-child': {
      borderTopRightRadius: 10,
      fontSize: 16,
      letterSpacing: 0.15
    }
  },
  tableRowWhite: {
    height: 70,
    background: 'white',
    border: 'none'
  },
  tableRow: {
    height: 70,
    background: '#F1F6F6',
    border: 'none'
  },
  tableData: {
    borderTop: 'none !important',
    ':first-child': {
      paddingLeft: 25,
      fontFamily: `Regular , ${theme.fontFamily}`,
      color: theme.colors.text[1]
    },
    ':first-child': {
      width: '25%',
      fontSize: 14
    },
    ':last-child': {
      width: 50,
      fontSize: 14
    },
    ':nth-child(2)': {
      width: '25%',
      fontSize: 14
    },
    ':nth-child(3)': {
      width: '25%',
      fontSize: 14
    },
    fontSize: '16px !important',
    fontFamily: `Regular , ${theme.fontFamily}`,
    color: theme.colors.text[1],
    fontSize: 14
  },
  editAndView: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 30
  },
  action: {
    width: 20,
    height: 20
  },
  status: {
    fontFamily: `SemiBold, ${theme.fontFamily}`,
    width: 140,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 8,
    fontSize: 13,
    borderRadius: 10
  },
  active: {
    background: '#D5F3B7',
    color: '#64B216',
    fontFamily: `Regular, ${theme.fontFamily}`
  },
  draft: {
    background: '#CAEBFE',
    color: '#2E95CE'
  },
  inactive: {
    background: '#F5DBDB',
    color: '#FC5858'
  },
  disabled: {
    background: '#DBDBDB',
    color: '#9C9C9C'
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    border: 'none !important',
    fontFamily: `SemiBold !important`,
    marginTop: 50,
    button: {
      border: 'none !important',
      backgroundColor: 'transparent',
      fontFamily: `SemiBold`
    }
  },
  displayDesktop: {
    display: 'block',
    [theme.fn.smallerThan('md')]: {
      display: 'none'
    }
  },
  displayMobile: {
    display: 'block',
    [theme.fn.largerThan('md')]: {
      display: 'none'
    }
  },
  plusIcon: {
    width: 14,
    height: 14,
    marginRight: 10
  }
}));
